<form id="catalog-gift-form" *ngIf="form && catalogGiftFields && catalogGiftItemFields" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g">
    <div class="ui-g-9 ui-md-9 ui-lg-9">
      <h1 *ngIf="giftId" class="step-title">{{ 'common.edit' | translate }} {{ 'catalog.gift' | translate }}</h1>
      <h1 *ngIf="!giftId" class="step-title">{{ 'common.add' | translate }} {{ 'catalog.gift' | translate }}</h1>
    </div>
    <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
      <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
    </div>
  </div>
  <div class="card">
    <div class="ui-g ui-fluid">
      <!-- Codice Articolo -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.itm_code.nullable}">{{ catalogGiftFields.itm_code.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="itm_code"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.itm_code"></app-validation-msg>
      </div>
      <!-- Descrizione -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.description.nullable}">{{ catalogGiftFields.description.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="description"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.description"></app-validation-msg>
      </div>
      <!-- ID -->
      <div class="ui-g-12 ui-md-4" *ngIf="giftId">
        <p>Id: {{giftId}}</p>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Upload Immagine -->
      <div class="ui-g-12 ui-md-2">
        <span class="label">{{ catalogGiftFields.img_b64.keyName }}</span>
        <label id="upload-img-label">
          <input
            type="file"
            (change)="uploadImg($event.target.files)"
            accept=".png, .jpg, .jpeg, .pdf"/>
            {{ 'common.upload' | translate }}
        </label>
      </div>
      <!-- URL Immagine -->
      <div class="ui-g-12 ui-md-2">
          <span class="label">{{ catalogGiftFields.img_url.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="img_url"/>
      </div>
      <!-- Anteprima Immagine -->
      <div class="ui-g-12 ui-md-4">
        <div id="img-container">
          <img [src]="f.img_url.value ? f.img_url.value : f.img_b64.value" width="100" alt="anteprima immagine">
          <button
            *ngIf="f.img_url.value || f.img_b64.value"
            pButton
            type="button"
            (click)="removeImage()"
            icon="fa fa-times"
            id="remove-img-btn"
            class="ui-button-danger btnDelete">
          </button>
        </div>
      </div>
      <!-- Flag Prenotabile -->
      <div class="ui-g-12 ui-md-4">
        <p-checkbox formControlName="flg_reserved" [binary]="true" [label]="catalogGiftFields.flg_reserved.keyName"></p-checkbox>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Tipologia Premio -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': true}">{{ catalogGiftFields.type_gift_id.keyName }}</span>
        <p-dropdown
          [options]="giftTypes"
          formControlName="type_gift_id"
          [placeholder]="'catalog.selectGiftType' | translate"
          [autoWidth]="false"
          (onChange)="checkDigitalGift($event)">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.type_gift_id"></app-validation-msg>
      </div>
      <!-- Tipologia Prenotazione -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.reservation_type.nullable}">{{ catalogGiftFields.reservation_type.keyName }}</span>
        <p-dropdown
          [options]="reservationTypes"
          formControlName="reservation_type"
          [placeholder]="'catalog.selectResType' | translate"
          [autoWidth]="false">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.reservation_type"></app-validation-msg>
      </div>
      <!-- Tipologia Consegna -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': true}">{{ catalogGiftFields.delivery_type.keyName }}</span>
        <div class="catalog-gift-dropdown-container">
          <p-dropdown
            [options]="deliveryTypes"
            formControlName="delivery_type"
            [placeholder]="'catalog.selectDelType' | translate"
            [autoWidth]="false"
            [disabled]="f.type_gift_id.value === 2">
          </p-dropdown>
        </div>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.delivery_type"></app-validation-msg>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Codice Host Articolo -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.itm_code_host.nullable}">{{ catalogGiftFields.itm_code_host.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="itm_code_host"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.itm_code_host"></app-validation-msg>
      </div>
      <!-- Categoria Premio -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': true}">{{ catalogGiftFields.category_gift_id.keyName }}</span>
        <p-dropdown
          [options]="categoryGiftDesc"
          formControlName="category_gift_id"
          [placeholder]="'catalog.selectCategoryGift' | translate"
          [autoWidth]="false">
        </p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.category_gift_id"></app-validation-msg>
      </div>
      <!-- Marca Prodotto -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.brand.nullable}">{{ catalogGiftFields.brand.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="brand"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogGiftFields.brand"></app-validation-msg>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Descrizione Estesa -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogGiftFields.long_descr.nullable}">{{ catalogGiftFields.long_descr.keyName }}</span>
        <p-editor type="html" class="fieldInput" formControlName="long_descr" [style]="{'height':'320px'}"></p-editor>
      </div>
    </div>
    <!-- Aggiungi Livelli -->
    <div class="ui-g">
      <div class="ui-g-11 ui-md-11 ui-lg-11">
        <h3 class="title">{{ 'catalog.levelDetail' | translate }}</h3>
      </div>
      <div class="ui-g-12 ui-md-12 ">
        <button pButton (click)="addLevel()" icon="fa fa-plus-circle" iconPos="right" type="button" class="k-generic-btn" label="{{ 'common.add' | translate }}"></button>
      </div>
    </div>
    <!-- Livelli -->
    <div formArrayName="levels" *ngIf="levels && levels.controls.length > 0 && catalogGiftItemFields">
      <div class="ui-g ui-fluid" *ngFor="let level of levels.controls; let i=index" [formGroupName]="i">
         <p-panel class="ui-g-12">
           <p-header>
             <div class="ui-helper-clearfix pull-left">
               <h3 class="title">{{ 'catalog.levels' | translate }}</h3>
             </div>
             <div class="ui-helper-clearfix pull-right">
               <button pButton type="button" (click)="confirmCancelDetail(level.get('id').value, i)" icon="fa fa-times" class="ui-button-danger btnDelete"></button>
             </div>
           </p-header>
           <div class="ui-g ui-fluid">
              <div class="ui-g-12  ui-fluid">
                <!-- Codice Articolo -->
                <div class="ui-g-12 ui-md-4">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.article_code.nullable}">{{ catalogGiftItemFields.article_code.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="article_code"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.article_code"></app-validation-msg>
                </div>
                <!-- Progressivo -->
                <div class="ui-g-12 ui-md-2">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.progres.nullable}">{{ catalogGiftItemFields.progres.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="progres"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.progres"></app-validation-msg>
                </div>
                <!-- Punti -->
                <div class="ui-g-12 ui-md-2">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.rdm_points.nullable}">{{ catalogGiftItemFields.rdm_points.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="rdm_points"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.rdm_points"></app-validation-msg>
                </div>
                <!-- Contributo -->
                <div class="ui-g-12 ui-md-2">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.rdm_value.nullable}">{{ catalogGiftItemFields.rdm_value.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="rdm_value"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.rdm_value"></app-validation-msg>
                </div>
              </div>
              <div class="ui-g-12  ui-fluid">
                <!-- Barcode -->
                <div class="ui-g-12 ui-md-4">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.barcode.nullable}">{{ catalogGiftItemFields.barcode.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="barcode"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.barcode"></app-validation-msg>
                </div>
                <!-- Barcode da Stampare -->
                <div class="ui-g-12 ui-md-2">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.barcode_print.nullable}">{{ catalogGiftItemFields.barcode_print.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="barcode_print"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.barcode_print"></app-validation-msg>
                </div>
                <!-- Formato Barcode -->
                <div class="ui-g-12 ui-md-2">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.barcode_format.nullable}">{{ catalogGiftItemFields.barcode_format.keyName }}</span>
                  <p-dropdown
                    [options]="barcodeFormats"
                    formControlName="barcode_format"
                    [placeholder]="'catalog.selectBarcodeFormat' | translate"
                    [autoWidth]="false">
                  </p-dropdown>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.barcode_format"></app-validation-msg>
                </div>
              </div>
              <div class="ui-g-12  ui-fluid">
                <!-- Tipologia Premio (Livello) -->
                <div class="ui-g-12 ui-md-4">
                  <span class="label" [ngClass]="{'required': !catalogGiftItemFields.itm_type.nullable}">{{ catalogGiftItemFields.itm_type.keyName }}</span>
                  <p-dropdown
                    [options]="giftItemTypes"
                    formControlName="itm_type"
                    [placeholder]="'catalog.selectGiftType' | translate"
                    [autoWidth]="false">
                  </p-dropdown>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="level" [validation]="catalogGiftItemFields.itm_type"></app-validation-msg>
                </div>
              </div>
            </div>
         </p-panel>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-gift/catalog-gift-detail/catalog-gift-detail.component.html